import styled, { css, keyframes } from 'styled-components';

const createShrinkKeyframes = (strokeDasharray, strokeDashoffset) => keyframes `
  0% {
    stroke-dashoffset: ${strokeDasharray};
  }

  30% {
    stroke-dashoffset: ${strokeDashoffset};
  }

  80% {
    stroke-dashoffset: ${strokeDashoffset};
  }

  100% {
    stroke-dashoffset: ${strokeDasharray};
  }
`;
const Circle = styled.circle `
  transform: rotate(-90deg);
  transform-origin: center;
  animation: rotate 1s linear infinite,
    ${props => createShrinkKeyframes(props.strokeDasharray, props.strokeDashoffset)}
      1s linear infinite;

  @keyframes rotate {
    0% {
      transform: rotate(-90deg);
    }

    30% {
      transform: rotate(-90deg);
    }

    60% {
      transform: rotate(90deg);
    }

    100% {
      transform: rotate(270deg);
    }
  }
`;
const Root = styled.div `
  position: relative;
  color: ${props => props.$color || 'inherit'};
`;
const Svg = styled.svg `
  ${props => props.$center &&
    css `
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `}
`;
const Children = styled.span `
  ${props => props.$loading &&
    css `
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export { Children, Circle, Root, Svg };
